export var getExtraItems = function getExtraItems(items, shouldGetThree) {
  var numberOfItems = shouldGetThree ? 3 : 5;
  return items.slice(numberOfItems);
};